/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CoreAddress, CoreUser } from "@mm-products/java-multima-framework";

export type TaxSelfRegistrationDto = {
    readonly _permissions?: Array<string>;
    companyAddress?: CoreAddress;
    companyIdNumber?: string;
    created?: string;
    creator?: string;
    creatorId?: string;
    firstName?: string;
    id?: string;
    lastName?: string;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    newsletter?: string;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    software?: TaxSelfRegistrationDto.software;
    softwareName?: string;
    status?: TaxSelfRegistrationDto.status;
    unreliablePayer?: boolean;
    user?: CoreUser;
    partnerCode?: string;
};

export namespace TaxSelfRegistrationDto {
    export enum software {
        POHODA = "POHODA",
        POHODA_SQL = "POHODA_SQL",
        FLEXIBEE = "FLEXIBEE",
        MONEYS3 = "MONEYS3",
        ISDOC = "ISDOC",
        OTHER = "OTHER",
    }

    export enum status {
        ACCEPTED = "ACCEPTED",
        REJECTED = "REJECTED",
        FINISHED = "FINISHED",
        TO_REVIEW = "TO_REVIEW",
    }
}
